module.exports = __webpack_public_path__ + "static/media/option-3.0d9c9aab.ogg";